import { render } from "./BusinessPartnersPage.vue?vue&type=template&id=a07c962a"
import script from "./BusinessPartnersPage.vue?vue&type=script&lang=js"
export * from "./BusinessPartnersPage.vue?vue&type=script&lang=js"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__